

























import type { NuxtError } from '@nuxt/types';
import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';

import { addBasePath } from '~/helpers/addBasePath';

export default defineComponent({
  components: {
    SfButton,
  },
  props: {
    error: {
      type: Object as PropType<NuxtError>,
      required: true,
    },
  },
  setup(props) {
    // console.log('error page', props.error);
    const handleToHome = () => {
      window.location.href = '/';
    };
    return {
      handleToHome,
      addBasePath,
    };
  },
});
